module.exports = __webpack_public_path__ + "static/img/dethmold.978431d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/dethmold.png
// module id = i99l
// module chunks = 0